module.exports = __webpack_public_path__ + "img/instagram.00cdbb9f.png";